
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/university/processes",
      function () {
        return require("private-next-pages/university/processes.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/university/processes"])
      });
    }
  